import { MAILFOOTER } from 'config/actionTypes'

const INIT_STATE = {
    isActive: false,
    editorState: null,
    fileLinks: [],
    recipients: {
      nachbarschaftshilfe: {
        requester: false,
        provider: false
      },
      pflegekasse: {
        requester: false,
        provider: false
      }
    }
}
function mailSenderReducer(state = INIT_STATE, action) {

  switch(action.type) {
    case MAILFOOTER.INIT_EDITOR : {
      return ({
          ...state,
          ...action.payload
      })
    }
    case MAILFOOTER.SET_EDITOR_STATE : {
      return ({
          ...state,
          editorState: action.payload
      })
    }
    case MAILFOOTER.RESET_EDITOR_STATE : {
      return ({
          ...state,
          editorState: '',
          fileLinks: [],
          isActive: false,
      })
    }
    case MAILFOOTER.SET_IMAGE_LINK : {
      return ({
          ...state,
          fileLinks: [...state.fileLinks, action.payload]
      })
    }
    default : return state;
  }
}
  
  export default mailSenderReducer